/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lib_Error_Handleresolvefailed2Inputs */

const en_lib_error_handleresolvefailed2 = /** @type {(inputs: Lib_Error_Handleresolvefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to resolve handle`)
};

/**
* | output |
* | --- |
* | "Unable to resolve handle" |
*
* @param {Lib_Error_Handleresolvefailed2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lib_error_handleresolvefailed2 = /** @type {((inputs?: Lib_Error_Handleresolvefailed2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lib_Error_Handleresolvefailed2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lib_error_handleresolvefailed2(inputs)
});
export { lib_error_handleresolvefailed2 as "lib.error.handleResolveFailed" }